module.exports = __webpack_public_path__ + "png/quick-registration-photo-bg.png?2366757650750336080f30ab40962a75";